(function(global){'use strict';const install=function(runtime){runtime.register("dragon-14",function(context){const {root,document,window,IntersectionObserver,ResizeObserver,requestAnimationFrame,cancelAnimationFrame,setTimeout,clearTimeout,setInterval,clearInterval,t:gtechT}=context;const errors=[];
try {


(()=>{"use strict";const panels=[...document.querySelectorAll("details.gtech-technical")];const expand=document.getElementById("gtech-dragon-14-expand-all");expand.hidden=false;const sync=()=>{const all=panels.every(p=>p.open);expand.textContent=all?gtechT('collapse_explanations_html'):gtechT('expand_explanations_html');expand.setAttribute("aria-label",expand.textContent);};expand.addEventListener("click",()=>{const open=!panels.every(p=>p.open);panels.forEach(p=>p.open=open);sync();});panels.forEach(p=>p.addEventListener("toggle",sync));const jump=document.getElementById("gtech-dragon-14-jump");jump.addEventListener("change",()=>{const target=document.getElementById(jump.value);if(target){location.hash=jump.value;target.setAttribute("tabindex","-1");target.focus({preventScroll:true});}});const sections=[...document.querySelectorAll("section.gtech-feature[id]")];const links=[...document.querySelectorAll("[data-nav]")];let ticking=false;let preferred=null;links.forEach(a=>a.addEventListener("click",()=>{preferred=a.dataset.nav;}));jump.addEventListener("change",()=>{preferred=jump.value;});const mark=()=>{const candidates=sections.filter(s=>s.getBoundingClientRect().top<=(Number(root.dataset.scrollThreshold)||160));const last=candidates[candidates.length-1]||sections[0];const row=candidates.filter(s=>Math.abs(s.getBoundingClientRect().top-last.getBoundingClientRect().top)<5);const chosen=row.find(s=>s.id===preferred)||row[0]||last;const current=chosen.id;links.forEach(a=>{if(a.dataset.nav===current)a.setAttribute("aria-current","location");else a.removeAttribute("aria-current");});if(document.activeElement!==jump)jump.value=current;ticking=false;};window.addEventListener("scroll",()=>{if(!ticking){requestAnimationFrame(mark);ticking=true;}},{passive:true});window.addEventListener("resize",mark);mark();})();


} catch (error) { errors.push({module:1,error}); }
try {


/* Conceptual flow animation. No computed CFD data, no automatic playback. */
(() => {
  'use strict';
  const root = document.getElementById('gtech-dragon-14-vortex-demo');
  if (!root || root.dataset.vortexReady === 'true') return;
  const play = root.querySelector('#gtech-dragon-14-vortex-play');
  const note = root.querySelector('#gtech-dragon-14-vortex-stage-note');
  const buttons = Array.from(root.querySelectorAll('[data-vortex-stage]'));
  if (!play || !note || buttons.length === 0) return;
  root.dataset.vortexReady = 'true';
  const notes = {
    "all": gtechT('vortex_overview_html'),
    "intake": gtechT('vortex_intake_html'),
    "bend": gtechT('vortex_bend_html'),
    "ports": gtechT('vortex_ports_html'),
    "flame": gtechT('vortex_flame_html')
};
  let wantsPlayback = false;
  let inView = true;
  const syncPlayback = () => {
    root.classList.toggle('gtech-is-playing', wantsPlayback && inView && !document.hidden);
    play.setAttribute('aria-pressed', String(wantsPlayback));
    const label = play.querySelector('[data-vortex-play-label]');
    if (label) label.textContent = wantsPlayback ? gtechT('pause_flow_html') : gtechT('play_flow_html');
    else play.textContent = wantsPlayback ? gtechT('pause_flow_html') : gtechT('play_flow_html');
  };
  const selectStage = (stage) => {
    const next = notes[stage] ? stage : 'all';
    root.dataset.stage = next;
    for (const button of buttons) {
      button.setAttribute('aria-pressed', String(button.dataset.vortexStage === next));
    }
    note.textContent = notes[next];
  };
  play.addEventListener('click', () => {
    wantsPlayback = !wantsPlayback;
    syncPlayback();
  });
  for (const button of buttons) {
    button.addEventListener('click', () => {
      const selected = button.dataset.vortexStage;
      selectStage(root.dataset.stage === selected ? 'all' : selected);
    });
  }
  document.addEventListener('visibilitychange', syncPlayback);
  if ('IntersectionObserver' in window) {
    const observer = new window.IntersectionObserver((entries) => {
      const entry = entries.find(item => item.target === root);
      if (!entry) return;
      inView = entry.isIntersecting;
      syncPlayback();
    }, { threshold: 0.05 });
    observer.observe(root);
  }
  // Every visitor, including a visitor preferring reduced motion, starts with a static diagram.
  selectStage(root.dataset.stage || 'all');
  syncPlayback();
})();



} catch (error) { errors.push({module:2,error}); }
try {

(function(){'use strict';
const shell=document.getElementById('gtech-dragon-14-ts-layer-demo');
if(shell){const buttons=Array.from(shell.querySelectorAll('[data-ts-select]'));const layers=Array.from(shell.querySelectorAll('[data-ts-layer]'));const notes={all:gtechT('insulation_overview_html'),upper:gtechT('insulation_upper_html'),rear:gtechT('insulation_rear_html'),base:gtechT('insulation_base_html')};buttons.forEach(button=>button.addEventListener('click',()=>{const area=button.dataset.tsSelect;shell.dataset.selection=area;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));layers.forEach(layer=>layer.setAttribute('opacity',area==='all'||layer.dataset.tsLayer===area?'1':'.25'));document.getElementById('gtech-dragon-14-ts-selection-note').textContent=notes[area];}));}
const joint=document.getElementById('gtech-dragon-14-tf-joint-demo');
if(joint){const buttons=Array.from(joint.querySelectorAll('[data-tf-state]'));const svg=joint.querySelector('.gtech-thermoflex-diagram');buttons.forEach(button=>button.addEventListener('click',()=>{const state=button.dataset.tfState;joint.dataset.state=state;svg.dataset.state=state;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));document.getElementById('gtech-dragon-14-tf-state-note').textContent=state==='heated'?gtechT('flex_heated_html'):gtechT('flex_cold_html');}));}
}());

} catch (error) { errors.push({module:3,error}); }
try {

(() => {
  'use strict';
  const preheat=document.getElementById('gtech-dragon-14-dr100-preheat');
  const descriptions={heat:gtechT('preheat_heat_html'),stone:gtechT('preheat_stone_html'),bake:gtechT('preheat_bake_html')};
  document.querySelectorAll('[data-dr-preheat]').forEach(button=>button.addEventListener('click',()=>{
    const stage=button.dataset.drPreheat;if(preheat)preheat.dataset.stage=stage;
    document.querySelectorAll('[data-dr-preheat]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    document.getElementById('gtech-dragon-14-dr-preheat-status').textContent=descriptions[stage];
  }));
})();


(function () {
  'use strict';

  var root = document.getElementById('gtech-dragon-14-inview-compare');
  if (!root || root.dataset.inviewComparisonReady === 'true') return;

  var turnButton = root.querySelector('#gtech-dragon-14-inview-turn');
  var turnLabel = root.querySelector('[data-inview-turn-label]');
  var turnDetail = root.querySelector('[data-inview-turn-detail]');
  var note = root.querySelector('#gtech-dragon-14-inview-comparison-note');
  var turned = root.dataset.turn === '1';
  var initialNote = gtechT('inview_initial_dragon_14_html');
  var turnedNote = gtechT('inview_turned_dragon_14_html');

  function sync() {
    root.dataset.mode = 'visibility';
    root.dataset.turn = turned ? '1' : '0';
    root.style.setProperty('--inview-r1-rotation', turned ? '90deg' : '0deg');
    root.style.setProperty('--inview-other-rotation', turned ? '180deg' : '0deg');
    if (turnButton) {
      turnButton.disabled = false;
      turnButton.setAttribute('aria-disabled', 'false');
      turnButton.setAttribute('aria-label', turned
        ? gtechT('reset_comparison_aria_html')
        : gtechT('turn_dragon_14_aria_html'));
    }
    if (turnLabel) turnLabel.textContent = turned ? gtechT('reset_comparison_html') : gtechT('turn_pizza_html');
    if (turnDetail) turnDetail.textContent = turned ? gtechT('return_start_html') : gtechT('turn_degrees_dragon_14_html');
    if (note) note.textContent = turned ? turnedNote : initialNote;
  }

  if (turnButton) {
    turnButton.addEventListener('click', function () {
      turned = !turned;
      sync();
    });
  }
  if (note) {
    note.setAttribute('aria-live', 'polite');
    note.setAttribute('aria-atomic', 'true');
  }
  root.dataset.inviewComparisonReady = 'true';
  sync();
}());



} catch (error) { errors.push({module:4,error}); }
try {

/* Mobile figure enlargement preserves the actual diagram and its live state. */
(() => {
  'use strict';
  document.documentElement.classList.add('gtech-mobile-enhanced');
  const media = window.matchMedia('(max-width: 1000px)');
  const selectors = ['.gtech-dr-graphic > svg', '.gtech-dr-graphic > img', '.gtech-vortex-svg-window > svg', '.gtech-ivcmp-top > svg', '.gtech-ivcmp-front > svg'];
  const figures = [];
  document.querySelectorAll(selectors.join(',')).forEach((graphic, index) => {
    const title = graphic.querySelector('title');
    const label = (title && title.textContent.trim()) || graphic.getAttribute('alt') || gtechT('technical_diagram_html');
    const viewBox = (graphic.getAttribute('viewBox') || '').trim().split(/\s+/);
    const intrinsicWidth = Number(viewBox[2]) || Number(graphic.getAttribute('width')) || 800;
    const expandedWidth = Math.max(720, Math.min(1450, intrinsicWidth * 1.25));
    const holder = document.createElement('div');
    holder.className = 'gtech-m130-figure';
    holder.style.setProperty('--figure-expanded-width', expandedWidth + 'px');
    const viewport = document.createElement('div');
    viewport.className = 'gtech-m130-viewport';
    viewport.id = 'gtech-dragon-14-figure-' + (index + 1);
    viewport.setAttribute('role', 'region');
    viewport.setAttribute('aria-label', label);
    const toolbar = document.createElement('div');
    toolbar.className = 'gtech-m130-tools';
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = gtechT('enlarge_diagram_html');
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-controls', viewport.id);
    button.setAttribute('aria-label', gtechT('enlarge_diagram_prefix_html') + label);
    const hint = document.createElement('span');
    hint.id = viewport.id + '-hint';
    hint.textContent = gtechT('swipe_explore_html');
    hint.hidden = true;
    toolbar.append(button, hint);
    graphic.parentNode.insertBefore(holder, graphic);
    holder.append(toolbar, viewport);
    viewport.append(graphic);
    const reset = () => {
      holder.classList.remove('gtech-is-enlarged');
      button.textContent = gtechT('enlarge_diagram_html');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', gtechT('enlarge_diagram_prefix_html') + label);
      hint.hidden = true;
      viewport.removeAttribute('tabindex');
      viewport.removeAttribute('aria-describedby');
      viewport.scrollLeft = 0;
      viewport.scrollTop = 0;
    };
    button.addEventListener('click', () => {
      if (!media.matches || holder.classList.contains('gtech-is-enlarged')) { reset(); return; }
      holder.classList.add('gtech-is-enlarged');
      button.textContent = gtechT('fit_diagram_html');
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', gtechT('fit_diagram_prefix_html') + label);
      hint.hidden = false;
      viewport.setAttribute('tabindex', '0');
      viewport.setAttribute('aria-describedby', hint.id);
    });
    viewport.addEventListener('keydown', event => {
      if (event.key === 'Escape') { reset(); button.focus(); }
    });
    figures.push({ reset });
  });
  const onResize = () => { if (!media.matches) figures.forEach(figure => figure.reset()); };
  if (media.addEventListener) media.addEventListener('change', onResize);
  else media.addListener(onResize);
})();


} catch (error) { errors.push({module:5,error}); }
if(errors.length){root.dataset.technologyErrors=String(errors.length);errors.forEach(item=>global.console.error('Glowen technology module failed',"dragon-14",item.module,item.error));} });};if(global.GlowenTechnologyPages)install(global.GlowenTechnologyPages);else(global.GlowenTechnologyQueue=global.GlowenTechnologyQueue||[]).push(install);})(window);